import MuiPopover from '@material-ui/core/Popover';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';

// Empty styles are just to help with console errors due to prop validation
const Popover = withStyles(theme => ({
  paper: ({
    borderRadius: ({ rounded }) => (rounded ? theme.radius.md : undefined),
  }),
}))(MuiPopover);
export default Popover;
